module.exports = __webpack_public_path__ + "assets/img/21_63.83c9275b.jpg";